import {injectable} from "inversify";
import Scene = Phaser.Scene;
import {RuneInfo} from "@/store/artifact/types";
import {RunePickPanel} from "@/scenes.ui/rune-pick-panel";
import ArtifactStore from "@/store/artifact";
import {Player} from "@/store/player/types";

@injectable()
export class RuneService {

    public openPlace(scene: Scene, canvas: HTMLCanvasElement, placeId: number,
                     awardSound: (Phaser.Sound.BaseSound | undefined), clickSound: (Phaser.Sound.BaseSound | undefined),
                     closeCallback: (removePlace: boolean) => unknown, runeTakenCallback: () => unknown): void {

        ArtifactStore.runePlaceInfo(placeId).then((ri: RuneInfo) => {

            let pickRunePanel = new RunePickPanel(scene, canvas, canvas.width / 2, canvas.height / 2 - 10, ri,
                () => {
                    closeCallback(false);
                }, () => {
                    ArtifactStore.takeRuneFromRoad(placeId).then((p: Player) => {
                        runeTakenCallback();
                    });
                    closeCallback(true);
                });
            pickRunePanel.openAnimated();
        });

    }
}
